
import {
  useDataSource,
  useGammaData,
  useMap,
  useOrgSettings,
} from "@/services";
import { computed, defineComponent, reactive, toRefs, watch } from "vue";
import { titleCase } from "@/util/helpers";

interface LocalState {
  activeSourceId: string;
  dataSources: string[];
  isVisible: boolean;
  sourceName: string;
}

export default defineComponent({
  name: "DatasetSelector",
  setup() {
    const loadedBooks = computed(() => useMap().loadedBooks);
    const state = reactive({
      activeSourceId: computed(
        () =>
          useGammaData().activeSourceId ||
          useGammaData().dataSources.filter((x) => isPolicyOrClaim(x))[0]
      ),
      dataSources: computed(() => {
        return useGammaData().dataSources.filter((name) => {
          if (!isPolicyOrClaim(name)) return;
          const dataSource = useDataSource(name)();
          return (
            (!!dataSource.source.businessLine &&
              dataSource.source.businessLine ===
                useOrgSettings().selectedBusinessLine?.name) ||
            loadedBooks.value.has(name)
          );
        });
      }),
      isVisible: computed(
        () => useDataSource(state.activeSourceId)().isVisible
      ),
      sourceName: computed(() => state.activeSourceId),
    }) as LocalState;

    watch(
      computed(() => useOrgSettings().selectedBusinessLine),
      () => {
        selectSource(state.dataSources[0]);
      },
      { immediate: true }
    );

    function isPolicyOrClaim(name: string): boolean {
      const dataSource = useDataSource(name)();
      return dataSource.type === "Policy" || dataSource.type === "Claim";
    }

    function selectSource(lcId: string) {
      useGammaData().selectDataSource({ lcId });
    }
    return {
      ...toRefs(state),
      titleCase,
      selectSource,
    };
  },
});
